import {Nav, Footer} from '../components'


import {Outlet} from 'react-router-dom'

import React, {useEffect, useState} from "react";
import {getSplash} from "../services/services";




const Mainlayout = ({children}) => {


    const getData = async () => {
        const response = await getSplash()
        if (response && response.data.code == 1) {
          localStorage.setItem("splash", JSON.stringify(response.data))
        } else {
            alert('مشکل در ارتباط با سرور')
        }
    }


    useEffect(() => {

        getData()
    }, []);







    return (
        <>
            <div className='is-flex is-flex-direction-column is-align-items-center clrone ' >



                    <Nav/>
                    {/*<div style={{height: '6rem'}}  />*/}
                    <Outlet/>


                    {children}




                <Footer/>

            </div>

        </>
    )
}
export default Mainlayout